import e from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_next_month_date.ts
var t = (t) => e(t).add(1, "month").format("YYYY-MM-DD");
export { t as get_next_month_date };

//# sourceMappingURL=get_next_month_date.js.map